import React, {useState} from "react";
import { Permissions } from "../../Constantes/permissions.constants";
import { PageContainer } from "@ant-design/pro-layout";
import { Secured } from "../../component";
import { Card, Form, DatePicker,Button } from "antd";
import { QueryFilter } from "@ant-design/pro-form";
import services from "../services";
import moment from "moment";


const RelatorioBloqueio = () => {


    const [form] = Form.useForm();
    const dataInicio = Form.useWatch("dataInicio", form);
     const [filterValues, setFilterValues] = useState();
    
        const [isDownloading, setIsDownloading] = useState(false);
    
        const handleButtonClick = async (props, type) => {
            try {
              if (props.form) {
                props.form.submit();
              }
          
              const values = await props.form.validateFields();
          
              if (isDownloading) {
                alert("O download está em andamento. Aguarde até que termine.");
                return;
              }
          
              let { dataInicio, dataFim } = values || {};
          
              dataInicio = dataInicio
                ? moment(dataInicio).clone().startOf("month").format("YYYY-MM-DD")
                : null;
          
              dataFim = dataFim
                ? moment(dataFim).clone().endOf("month").format("YYYY-MM-DD")
                : null;
          
              if (!dataInicio) {
                alert("Data de início é obrigatória.");
                return;
              }
          
              const params = { dataInicio, dataFim, tipo: type };
          
              setIsDownloading(true);
          
              await services.downloadRelatorioBloqueioPorPeriodo(params);
          
            } catch (err) {
              console.warn("Erro ao gerar o relatório:", err);
              alert(err.message || "Corrija os campos do formulário ou tente novamente.");
            } finally {
              setIsDownloading(false);
            }
          };
    
    return (
        <>
            <Secured hasAnyRole={Permissions.RELATORIOS.TELA} isShowErro403={true}>
                <PageContainer>
                    <h1>Relatório Bloqueio Censo</h1>
                </PageContainer>
            </Secured>

             <Card
                title="Parâmetros Relatório"
                style={{
                fontSize: "20px",
                marginBottom: "10px",
                position: "relative",
                }}

                


            >

                 <QueryFilter
                    form={form}
                    onFinish={(values) => handleButtonClick(values, 'pdf')} // Adicionando ação para PDF
                    onReset={() => setFilterValues({ page: 0, size: 10 })}  
                    layout="vertical"
                    defaultCollapsed
                    className="filtro"
                    submitter={{
                        render: (props, dom) => (
                            <>
                                <div style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',  
                                    justifyContent: 'flex-start',
                                    gap: '10px',
                                    width: '100%',     
                                }}>
                                    {dom[0]} {/* Botão de limpar */}
                                    <Button type="primary" onClick={() => handleButtonClick(props, 'pdf')}style={{ flexShrink: 0 }}>
                                        Download Pdf
                                    </Button>

                                    <Button type="primary" onClick={() => handleButtonClick(props, 'csv')} style={{
                                        flexShrink: 0,
                                        backgroundColor: '#4CAF50',
                                        borderColor: '#4CAF50',
                            
                        }}>
                                        Download Excel
                                    </Button>
                                </div>
                            </>
                        ),
                    }}
                >


                   <Form.Item
                        name="dataInicio"
                        label="Período Inicial"
                        rules={[{ required: true, message: "Período inicial é obrigatório" }]}
                        >
                        <DatePicker
                            picker="month"
                            format="MM/YYYY"
                            placeholder="Selecione mês e ano"
                            allowClear
                            onChange={() => {
                            form.setFieldsValue({ dataFim: null }); // limpa o período final
                            }}
                        />
                    </Form.Item>


                    <Form.Item
                        name="dataFim"
                        label="Período Final"
                        dependencies={["dataInicio"]}
                        rules={[
                            { required: true, message: "Período final é obrigatório" },
                            ({ getFieldValue }) => ({
                            validator(_, value) {
                                const dataInicio = getFieldValue("dataInicio");

                                if (!dataInicio || !value) return Promise.resolve();

                                if (value.isBefore(dataInicio, "month")) {
                                return Promise.reject(
                                    new Error("O mês final não pode ser anterior ao mês inicial.")
                                );
                                }

                                const diff = value.diff(dataInicio, "months");
                                if (diff > 12) {
                                return Promise.reject(
                                    new Error("O período não pode ser superior a 12 meses.")
                                );
                                }

                                return Promise.resolve();
                            },
                            }),
                        ]}
                        >
                        <DatePicker
                            picker="month"
                            format="MM/YYYY"
                            placeholder="Selecione mês e ano"
                            allowClear
                            disabled={!dataInicio}
                            disabledDate={(current) =>
                            dataInicio && current.isBefore(dataInicio, "month")
                            }
                            onChange={(value) => {
                            const dataInicio = form.getFieldValue("dataInicio");

                            if (dataInicio && value) {
                                const diff = value.diff(dataInicio, "months");

                                if (diff > 12) {
                                form.setFieldsValue({ dataFim: null });

                                form.setFields([
                                    {
                                    name: "dataFim",
                                    errors: ["O período não pode ser superior a 12 meses."],
                                    },
                                ]);
                                }
                            }
                            }}
                        />
                    </Form.Item>

                
                </QueryFilter>
            </Card>
            
        </>)
    
}

export default RelatorioBloqueio;